import { PrintWidgetApi } from './print-widget-api';
import { Subject } from 'rxjs'

class PrintWidget {
    constructor(el=null) {
        this._el = el;
        this._linkEl = el!=null ? el.querySelecotor('a') : null;
        this._api = null;
        this._onClick = null;

    }
    init(){
        this.linkEl.addEventListener('click',this.handleClick.bind(this));
        this.onClick.subscribe(e=>{
            this.api.print();
        })
    }
    get api(){
        if(this._api==null){
            this._api = new PrintWidgetApi();
        }
        return this._api;
    }
    get onClick(){
        if(this._onClick==null){
            this._onClick = new Subject();
        }
        return this._onClick;
    }
    get el() {
        if (this._el == null) {
            let el = document.createElement('div');
            el.classList.add('medscape-print-widget');
            el.appendChild(this.linkEl);
            this._el = el;
        }
        return this._el;
    }
    get linkEl() {
        if (this._linkEl == null) {
            let linkEl = document.createElement('a');
            this._linkEl = linkEl;
        }
        return this._linkEl;
    }
    handleClick(e){
        this.onClick.next(e);
    }

}

export { PrintWidget }